import { Select } from 'antd';
import React, { Component } from 'react'
import { findWhere } from '../../../../utils/db_functions.js';

const priceCompositionFields = (props) => {

    return [
        [
            {
                title: 'Código do Produto',
                key: 'product_code_in_price_composition_fields',
                type: "render",
                colSize: 5,
                render: (_) => {
                    return (
                        <div style={{ fontWeight: 'bold', fontSize: 'larger' }}>
                            {_.formRef.product_code}
                        </div>
                    );
                },
            }
        ],
        [
            {
                title: 'Total de matéria prima',
                key: 'total_primary_mat',
                type: "render",
                colSize: 5,
                render: (_) => {
                    return (
                        <div style={{ lineHeight: '40px', fontWeight: 'bold', fontSize: 'larger' }}>
                            {props.calculateTotalCost(_.formRef.descriptions).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </div>
                    );
                },
            },
            {
                title: "Acabamento (apenas para simulação de preço)",
                key: "finishing_to_calculate_price_render",
                type: "render",
                colSize: 8,
                render: (_, form) => {
                    return (
                        <FinishingSelectClass
                            finishingIds={(_.formRef.finishing_options_inputs || []).map(finishing => finishing.finishing)}
                            setFinishing={e => {
                                _.formRef.finishing_to_calculate_price = e
                                form.forceUpdate()
                            }}
                            finishingToCalculatePrice={_.formRef.finishing_to_calculate_price || null}
                        />
                    )
                }
            },
            { key: 'finishing_to_calculate_price' }
        ],
        [
            {
                title: 'Referência HH',
                key: 'unity_value_hh',
                type: 'pointer',
                colSize: 8,
                options: props.manHours.map(manHour => {
                    return { value: manHour.id, label: `${manHour.get('description')}` }
                }),
                'relation-select': {
                    class: 'ManHour',
                    label: 'description',
                    value: 'objectId',
                    key: 'objectId'
                },
                // loadFirstValue: true,
                'element-attr': { required: false, mode: 'default' }
            },
            {
                title: 'Quantidade HH',
                key: 'size_hh',
                type: "number",
                colSize: 3,
            },
            {
                title: 'Valor unitário HH',
                key: 'ref_unity_value_hh',
                type: 'render',
                colSize: 3,
                render: (form, node, value) => {
                    const manHour = props.manHours.find((manHour) => manHour.id === form.formRef.unity_value_hh)

                    return (
                        <div style={{ lineHeight: '40px', fontWeight: 'bold' }}>
                            {((manHour && manHour.get('calculatedTotal')) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </div>
                    )
                }
            },
            {
                title: 'Total mão de obra',
                key: 'total_hand',
                type: "render",
                colSize: 3,
                render: (form, node, value) => {
                    const manHour = props.manHours.find((manHour) => manHour.id === form.formRef.unity_value_hh)

                    return (
                        <div style={{ lineHeight: '40px', fontWeight: 'bold' }}>
                            {(((manHour && manHour.get('calculatedTotal')) || 0) * form.formRef.size_hh).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </div>
                    )
                }
            }
        ],
        [
            {
                title: 'Custo de produção (MP + Mão de obra)',
                key: 'production_cost',
                type: "render",
                colSize: 8,
                render: (form) => {
                    let total = 0;

                    const manHour = props.manHours.find((manHour) => manHour.id === form.formRef.unity_value_hh)
                    if (manHour) {
                        let component = { ...form.formRef }
                        if (form.formRef.finishing_to_calculate_price)
                            component["descriptions"] = [
                                ...component["descriptions"],
                                ...component["finishing_options_inputs"].filter(el => el.finishing === form.formRef.finishing_to_calculate_price)
                            ]

                        total = props.calculateProductionCost({ ...component, ref_unity_value_hh: manHour.get('calculatedTotal') })
                    }

                    return (
                        <div style={{ lineHeight: '40px', fontWeight: 'bold', fontSize: 'larger' }}>
                            {total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </div>
                    );
                },
            }
        ],
        [
            {
                title: 'ICMS (18%) + Federal (6,29%)',
                key: 'pis_conf',
                type: 'number',
                colSize: 6,
                'element-attr': { required: false },
            },
            {
                title: 'Custo Fixo + Comercial (%)',
                key: 'custo_comer',
                type: 'number',
                colSize: 6,
                'element-attr': { required: false },
            },
            {
                title: 'Margem de contribuição (%)',
                key: 'margin_contri',
                type: 'number',
                colSize: 6,
                'element-attr': { required: false },
            },
        ],
        [
            {
                title: 'Preço Margem Zero',
                key: 'price_margin_zero',
                type: "render",
                colSize: 8,
                render: (form) => {
                    let total = 0;

                    const manHour = props.manHours.find((manHour) => manHour.id === form.formRef.unity_value_hh)
                    if (manHour) {
                        let component = { ...form.formRef }
                        if (form.formRef.finishing_to_calculate_price)
                            component["descriptions"] = [
                                ...component["descriptions"],
                                ...component["finishing_options_inputs"].filter(el => el.finishing === form.formRef.finishing_to_calculate_price)
                            ]

                        total = props.calculateTotal({ ...component, ref_unity_value_hh: manHour.get('calculatedTotal') }, true)
                    }

                    return (
                        <div>
                            <div style={{ lineHeight: '40px', fontWeight: 'bold', fontSize: 'larger' }}>
                                {total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </div>
                            <div>ICMS (18%) + Federal (6,29%): {(total * (form.formRef.pis_conf / 100)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                            <div>Custo Fixo + Comercial: {(total * (form.formRef.custo_comer / 100)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                        </div>
                    );
                },
            },
            {
                title: 'Preço Margem Atribuída',
                key: 'price_margin_applied',
                type: "render",
                colSize: 8,
                render: (form) => {
                    let total = 0;

                    const manHour = props.manHours.find((manHour) => manHour.id === form.formRef.unity_value_hh)
                    if (manHour) {
                        let component = { ...form.formRef }
                        if (form.formRef.finishing_to_calculate_price)
                            component["descriptions"] = [
                                ...component["descriptions"],
                                ...component["finishing_options_inputs"].filter(el => el.finishing === form.formRef.finishing_to_calculate_price)
                            ]

                        total = props.calculateTotal({ ...component, ref_unity_value_hh: manHour.get('calculatedTotal') })
                    }

                    return (
                        <div>
                            <div style={{ lineHeight: '40px', fontWeight: 'bold', fontSize: 'larger' }}>
                                {total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </div>
                            <div>ICMS (18%) + Federal (6,29%): {(total * (form.formRef.pis_conf / 100)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                            <div>Custo Fixo + Comercial: {(total * (form.formRef.custo_comer / 100)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                            <div>Margem de Contribuição: {(total * (form.formRef.margin_contri / 100)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                        </div>
                    );
                },
            },
        ]
    ]
}

class FinishingSelectClass extends Component {
    constructor(props) {
        super(props)
        this.state = {
            finishings: [],
        }
    }

    componentDidMount = async () => {
        const finishings = await findWhere("Finishing", "objectId", this.props.finishingIds || [], null, null, "code")
        this.setState({ finishings })
    }

    render() {
        return (
            <div>
                <Select
                    size='large'
                    value={this.props.finishingToCalculatePrice}
                    onChange={e => this.props.setFinishing(e)}
                >
                    <Select.Option value={null}>Sem acabamento</Select.Option>
                    {
                        this.state.finishings.map(finishing => {
                            return (
                                <Select.Option value={finishing.id} key={finishing.id}>{finishing.get("code")} - {finishing.get("description")}</Select.Option>
                            )
                        })
                    }
                </Select>
            </div>
        )
    }
}

export default priceCompositionFields